<template>
  <div class="page-template">
    <div class="page-title">{{ title }}
    </div>
    <div class="page-edit">
      <form-template ref="formTemplate" @submit="submitData">
      </form-template>
    </div>
  </div>
</template>

<script>
import formTemplate from "@/components/template/formTemplate";
import api from "@/config/api";

export default {
  components: {formTemplate},
  data() {
    return {
      title: '',
      dialogVisibility: false,
      addColumns: {
        formType: 'other',
        labelWidth: "280px",
        span: 24,
        columns: [
          {label: '基础设置', type: 'title'},
          {
            label: "",
            type: "id",
          },
          {
            label: "金额尾数处理方式",
            type: "select",
            prop: "type",
            change: this.typeChange,
            data: [{value: 1, label: "不处理"},
              {value: 2, label: "抹掉分"},
              {value: 3, label: "抹掉角"},
              {value: 4, label: "抹掉元"},
              {value: 5, label: "四舍五入到角"},
              {value: 6, label: "四舍五入到元"},],
            defaultValue: 1,
          },
          {
            //金额尾数处理方式
            label: "",
            prop: "discountType",
            isShow: false
          },
          {
            //抹零范围
            label: "",
            prop: "malingType",
            isShow: false
          },
          {
            //整取方式
            label: "",
            prop: "lumpSum",
            isShow: false
          },
          {
            //保留位数
            label: "",
            prop: "decimalNum",
            isShow: false
          },
          {
            label: "每单必须选择导购员",
            type: "radio",
            prop: "orderMustGuide",
            data: [{label: '启用', id: 1}, {label: '不启用', id: 0},]
          },
          {
            label: "前台允许销售价格为0 的产品",
            type: "radio",
            prop: "allowSale",
            data: [{label: '启用', id: 1}, {label: '不启用', id: 0},]
          },
          {
            label: "单品折扣/议价后可进行整单议价/折扣",
            type: "radio",
            prop: "wholeOrderDiscount",
            data: [{label: '启用', id: 1}, {label: '不启用', id: 0},]
          },
          {
            label: "负库存禁止销售",
            type: "radio",
            prop: "negativeInventorySale",
            data: [{label: '启用', id: 1}, {label: '不启用', id: 0},]
          },
          {
            label: "前台显示会员优惠参照类别",
            type: "select",
            prop: "memberCategoryId",
            data: [],
            url: api.member.category
          },
          {
            label: "收银机不按单退货授权密码",
            type: "input",
            prop: "authorizationCode",
            rule: [
              {required: false, min: 4, max: 8, message: "密码长度为4-8数字", trigger: "change", pattern: "[0-9]"},
            ],
          },
        ],
        formData: {}
      }
    }
  },
  mounted() {
    this.title = document.title;
    this.getData();
  },
  methods: {
    typeChange(row) {
      switch (row.type) {
        case 1:
          row.discountType = 20;
          row.lumpSum = 10;
          row.decimalNum = 2;
          break;
        case 2:
          row.discountType = 10;
          row.malingType = 10;
          break;
        case 3:
          row.discountType = 10;
          row.malingType = 20;
          break;
        case 4:
          row.discountType = 10;
          row.malingType = 30;
          break;
        case 5:
          row.discountType = 20;
          row.lumpSum = 10;
          row.decimalNum = 1;
          break;
        case 6:
          row.discountType = 20;
          row.lumpSum = 10;
          row.decimalNum = 0;
          break;
        default:
          break;
      }
    },

    submitData(formModel) {
      this.$axios.fetchPost(api.archives.asRetailDefault, formModel).then(data => {
        if (data.code === 200) {
          Object.assign(formModel, data.data);
          this.$notify({
            type: "success",
            title: '保存操作',
            message: '成功',
            showClose: false,
          });
          // this.$message({type: 'success', message: '操作成功'});
        } else {
          this.$message({type: 'error', message: data.errorMsg});
        }
      }).catch((e) => {
        this.$notify({
          type: "error",
          title: '保存操作',
          message: '失败',
          showClose: false,
        });
        // this.$message({type: 'error', message: '修改失败'});
      });
    },
    getData() {
      this.$axios.fetchPost(api.archives.getRetailDefault, {}).then(data => {
        if (data.code === 200) {
          let row = data.data;
          console.log("discountType:" + row.discountType)
          console.log("lumpSum:" + row.lumpSum)
          console.log("decimalNum:" + row.decimalNum)
          console.log("malingType:" + row.malingType)
          if (row.discountType === 20 && row.lumpSum === 10 && row.decimalNum >= 2) {
            row.type = 1;
          }else  if ((row.discountType === 20 && row.lumpSum === 20 && row.decimalNum === 1)
            || (row.discountType === 10 && row.malingType === 10)) {
            row.type = 2;
          }else if ((row.discountType === 20 && row.lumpSum === 20 && row.decimalNum === 1)
            || (row.discountType === 10 && row.malingType === 20)) {
            row.type = 3;
          }else if (row.discountType === 10 && row.malingType === 30) {
            row.type = 4;
          }else if (row.discountType === 20 && row.lumpSum === 10 && row.decimalNum === 1) {
            row.type = 5;
          }else if (row.discountType === 20 && row.lumpSum === 10 && row.decimalNum === 0) {
            row.type = 6;
          } else {
            row.type = 1;
          }
          this.addColumns.formData = row;
          this.$refs['formTemplate'] && this.$refs['formTemplate'].initData(this.addColumns);
        } else {
          this.$message({type: 'error', message: data.errorMsg});
        }
      }).catch((e) => {
        console.log(e)
        this.$message({type: 'error', message: '请求失败'});
      });
    },
    getDiscountType(row) {
      let lumpSum = this.addColumns.columns.filter(item => item.prop === 'lumpSum')[0];
      let decimalNum = this.addColumns.columns.filter(item => item.prop === 'decimalNum')[0];
      let malingType = this.addColumns.columns.filter(item => item.prop === 'malingType')[0];
      //console.log(row, '&&&&&&&&&&&&&&&&&&&&&&');
      if (row['discountType'] === 10) {
        lumpSum.isShow = false;
        decimalNum.isShow = false;
        decimalNum.rule[0].required = false;
        malingType.rule[0].required = true;
        malingType.isShow = true;
        row.lumpSum = '';
        row.decimalNum = '';
      }
      if (row['discountType'] === 20) {
        lumpSum.isShow = true;
        decimalNum.isShow = true;
        malingType.isShow = false;
        decimalNum.rule[0].required = true;
        malingType.rule[0].required = false;
        row.malingType = '';
      }
    },
  }
}
</script>

<style scoped>
  >>> .column-title::before {
    content: "";
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 5px;
    margin-bottom: 2px;
    background: rgba(95, 88, 230);
  }

  >>> .el-radio__label {
    margin-right: 42px;
  }
</style>



// WEBPACK FOOTER //
// src/page/retail/Setting.vue